/* Drag&Drop — canonical PDP rail badge stack — v46 — 2026-08-18 */
(() => {
  'use strict';
  const DD_RAIL_COPY={"tr":{"sale":"İndirim","shipping":"Ücretsiz Kargo"},"en":{"sale":"Sale","shipping":"Free shipping"},"es":{"sale":"Oferta","shipping":"Envío gratuito"},"ru":{"sale":"Скидка","shipping":"Бесплатная доставка"},"ar":{"sale":"خصم","shipping":"شحن مجاني"},"de":{"sale":"Angebot","shipping":"Kostenloser Versand"},"fr":{"sale":"Promotion","shipping":"Livraison gratuite"}};
  const ddRailCopy=()=>DD_RAIL_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_RAIL_COPY.tr;
  const VERSION = '2026-09-28-product-rail-stack-v47';
  if (window.__ddProductRailStackV46 === VERSION) return;
  window.__ddProductRailStackV46 = VERSION;

  function setTextIfChanged(node, value) {
    if (!node) return false;
    const next = String(value == null ? '' : value);
    if (node.textContent === next) return false;
    node.textContent = next;
    return true;
  }

  function cardsIn(root) {
    const cards = [];
    if (root instanceof Element && root.matches('#MainContent .ddpd-section .ddnn-card')) cards.push(root);
    root?.querySelectorAll?.('#MainContent .ddpd-section .ddnn-card').forEach(card => cards.push(card));
    return cards;
  }

  function normalize(card) {
    const media = card.querySelector('.ddnn-card__media');
    if (!media) return;

    const containers = Array.from(media.querySelectorAll('.ddnn-card__badges'));
    let canonical = containers.find(node => node.parentElement === media) || null;
    if (!canonical) {
      canonical = document.createElement('div');
      canonical.className = 'ddnn-card__badges';
      media.appendChild(canonical);
    }

    const saleNodes = Array.from(media.querySelectorAll('.ddnn-badge--sale'));
    const shippingNodes = Array.from(media.querySelectorAll('.ddnn-badge--shipping'));
    const sale = saleNodes[0] || null;
    let shipping = shippingNodes[0] || null;

    if (sale) {
      sale.classList.add('ddnn-badge', 'ddnn-badge--sale');
      setTextIfChanged(sale, ddRailCopy().sale);
    }
    if (!shipping) {
      shipping = document.createElement('span');
      shipping.className = 'ddnn-badge ddnn-badge--shipping';
    }
    shipping.classList.add('ddnn-badge', 'ddnn-badge--shipping');
    setTextIfChanged(shipping, ddRailCopy().shipping);

    const desired = [sale, shipping].filter(Boolean);
    const stable = canonical.dataset.ddCanonicalRailBadges === 'v46' &&
      canonical.children.length === desired.length &&
      desired.every((node, index) => canonical.children[index] === node);
    if (!stable) canonical.replaceChildren(...desired);
    canonical.dataset.ddCanonicalRailBadges = 'v46';

    containers.forEach(container => {
      if (container !== canonical && container.isConnected) container.remove();
    });
    media.querySelectorAll('.ddnn-badge--sale,.ddnn-badge--shipping').forEach(node => {
      if (node.parentElement !== canonical) node.remove();
    });
    card.dataset.ddCanonicalRailBadges = 'v46';
  }

  function apply(root = document) {
    cardsIn(root).forEach(normalize);
  }

  let queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply(document);
    });
  }

  function start() {
    apply(document);
    const main = document.querySelector('#MainContent');
    if (main) {
      new MutationObserver(mutations => {
        const hasNewCard = mutations.some(mutation =>
          Array.from(mutation.addedNodes || []).some(node =>
            node instanceof Element &&
            (node.matches('.ddpd-section .ddnn-card') || node.querySelector('.ddpd-section .ddnn-card'))
          )
        );
        if (hasNewCard) queue();
      }).observe(main, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', event => {
      apply(event.target || document);
      window.setTimeout(() => apply(event.target || document), 80);
    });
    [120, 400, 900].forEach(delay => window.setTimeout(() => apply(document), delay));
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
